let UUID = 0;

const allDropDowns = [];

function isMobile() {
  return window.innerWidth <= 1024 && window.innerHeight > window.innerWidth; 
}

export default class AppDropdown extends HTMLElement {
  constructor() {
    super();
    this._opened = false;
    this.el = this;
    this.toggle = this.toggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  connectedCallback() {
    const id = 'dropdown-' + (UUID++);

    this.$button  = this.querySelector('[data-dropdown-button]');
    this.$content = this.querySelector('[data-dropdown-content]');

    allDropDowns.push({
      id,
      el: this
    });

    this.$button.setAttribute('id', `${id}-title`);
    this.$button.setAttribute('aria-controls', `${id}-content`);
    this.$button.addEventListener('click', this.toggle);

    this.disableMobileFocusOut = this.hasAttribute('disable-mobile-focus-out');

    this.$content.setAttribute('id', `${id}-content`);
    this.$content.setAttribute('aria-labelledby', `${id}-title`);
    this.$content.setAttribute('aria-hidden', true);
    this.$content.style.display = 'none';

    // Listen for changes on inputs inside the dropdown
    this.$content.addEventListener('change', this.handleChange);

    // Initialize label on page load
    this.updateLabel();

    this.addEventListener('focusout', e => this.handleFocusOut(e));

    this.preventFocusOut = false;
    this.addEventListener('mousedown', e => {
      this.preventFocusOut = true;
      requestAnimationFrame(()=>{
        this.preventFocusOut = false;
      });
    });
    
  }

  handleFocusOut(e) {
    // Wait a tick so activeElement is updated after blur
    if (!this.preventFocusOut && (!isMobile() || !this.disableMobileFocusOut)) {
      requestAnimationFrame(() => {
        if (!this.contains(document.activeElement)) {
          this.close();
        }
      });
    }
  }

  handleChange(e) {
    if (e.target.matches('input[type="radio"]')) {
      this.updateLabel(e.target);
    }
  }

  updateLabel(selectedInput = null) {
    const active = selectedInput || this.$content.querySelector('input[type="radio"]:checked');
    if (!active) return;
    return;
    const labelEl = this.$button.querySelector('[label]');
    const baseLabel = labelEl.dataset.baseLabel || labelEl.textContent.trim();
    // store original label only once
    if (!labelEl.dataset.baseLabel) {
      labelEl.dataset.baseLabel = baseLabel;
    }
    // find the human label of the selected input
    const inputLabel = this.$content.querySelector(`label[for="${active.id}"]`);
    const valueLabel = inputLabel ? inputLabel.textContent.trim() : active.value;
    labelEl.textContent = `${baseLabel}: ${valueLabel}`;
  }

  handleClickOutside(event) {
    if (!this.contains(event.target) && (!isMobile() || !this.disableMobileFocusOut)) {
      this.close();
    }
  }

  handleKeyDown(event) {

    if (event.key === 'Escape') {
      this.close();
      this.$button.focus(); // optional: return focus to button
    }
  }

  toggle() {

    this._opened ? this.close() : this.open();
  }

  open() {

    // Close all dropdown on the page
    allDropDowns?.forEach(dd => {
      if (dd.id !== this.id) {
        dd.el?.close();
      }
    });

    this._opened = true;
    this.$button.setAttribute('aria-expanded', 'true');
    this.$content.setAttribute('aria-hidden', 'false');
    this.classList.add('is-active');
    this.$content.style.removeProperty('display');
    this.style.zIndex = 11;
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeyDown);

  }

  close() {
    this._opened = false;
    this.$button.setAttribute('aria-expanded', 'false');
    this.$content.setAttribute('aria-hidden', 'true');
    this.classList.remove('is-active');
    this.$content.style.display = 'none';
    this.style.removeProperty('z-index');
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown); 
  }

  disconnectedCallback() {
    this.$button.removeEventListener('click', this.toggle);
    this.$content.removeEventListener('change', this.handleChange);
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
  }
}

customElements.define('app-dropdown', AppDropdown);
